import React from "react"

function IconCloudUpload({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="cloud-upload"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-cloud-upload"
      {...props}
    >
      <path
        d="M11.678 13.261a.655.655 0 0 1 .744 0l.091.076 2.353 2.353.076.09a.655.655 0 0 1 0 .745l-.076.09-.09.076a.655.655 0 0 1-.745 0l-.09-.075-1.237-1.237v5.6l-.008.106a.655.655 0 0 1-1.292 0l-.008-.106-.001-5.598-1.235 1.235-.09.075a.655.655 0 0 1-.911-.91l.075-.091 2.353-2.353.091-.076zm-.767-10.643a6.592 6.592 0 0 1 6.2 4.357l.084.25.052.179.171.004a4.745 4.745 0 0 1 4.492 4.282l.016.227.006.23c0 2.543-2 4.618-4.514 4.738l-.23.006h-1.324c.206-.408.23-.885.073-1.31h1.251a3.434 3.434 0 0 0 .195-6.864l-.195-.005-.08.004-.296.037a.655.655 0 0 1-.714-.53 5.279 5.279 0 0 0-10.424.344.655.655 0 0 1-.362.51 3.418 3.418 0 0 0-1.93 3.07 3.434 3.434 0 0 0 3.24 3.429l.194.005h1.347c-.157.425-.133.902.073 1.31h-1.42a4.743 4.743 0 0 1-4.743-4.744c0-1.582.787-3.017 2.05-3.887l.204-.133.098-.058.029-.158a6.59 6.59 0 0 1 5.933-5.272l.268-.016.256-.005z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconCloudUpload
